import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import IconButton from 'material-ui/IconButton'
import Input, {InputAdornment} from 'material-ui/Input'
import {FormControl} from 'material-ui/Form'
import SearchIcon from 'material-ui-icons/Search'
import ClearIcon from 'material-ui-icons/Clear'
import classNames from 'classnames'

const styles = () => ({
  formControl: {
    minWidth: 240,
    marginTop: 8,
  },
  formControlMini: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    marginTop: '0 !important',
    zIndex: 5,
    background: '#FFF',
    padding: '15px 15px 10px 15px',
    boxSizing: 'border-box',
  },
  text: {
    // top: -4,
  },
  icon: {
    // top: 7,
    width: 32,
    height: 32,
  },
  iconButton: {
    marginTop: 5,
  },
})

class Search extends React.Component {

  state = {
    open: false,
  }

  setOpen = (open) => this.setState({open})

  render() {
    const {classes, mini, searchText, setSearch} = this.props
    return (
      <div>
        {this.state.open === false
          ? <IconButton onClick={() => this.setOpen(true)} className={classes.iconButton}><SearchIcon/></IconButton>
          : (
            <FormControl className={classNames(classes.formControl, {
              [classes.formControlMini]: mini,
            })}>
              <Input
                id="search"
                startAdornment={
                  <InputAdornment position="start">
                    <IconButton className={classes.icon}>
                      <SearchIcon/>
                    </IconButton>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton className={classes.icon} onClick={() => {
                      this.setOpen(false)
                      setSearch('')
                    }}>
                      <ClearIcon/>
                    </IconButton>
                  </InputAdornment>
                }
                value={searchText}
                onChange={e => setSearch(e.target.value)}
              />
            </FormControl>
          )
        }
      </div>
    )
  }

  static propTypes = {
    searchText: PropTypes.string.isRequired,
    setSearch: PropTypes.func.isRequired,
    mini: PropTypes.bool,
  }
}

export default withStyles(styles)(Search)



// WEBPACK FOOTER //
// ./src/sections/header/components/search.js